import { useEffect, useState } from "react";
import useUserGeoLocation from "./use-user-geo-location";

const buildLocationEventPayload = (userGeoData = {}, geoPermissionState = null) => {
    const city = userGeoData?.city?.name || "";
    const state = userGeoData?.state?.name || "";
    const pincode = userGeoData?.postalCode || userGeoData?.pincode || "";
    const eventLabel = [city, state, pincode].filter(Boolean).join(" | ");
    const hasValidCoordinates =
        typeof userGeoData?.coordinates?.lat === "number" && typeof userGeoData?.coordinates?.lng === "number";
    const eventAction = geoPermissionState !== "denied" && hasValidCoordinates ? "geo_coordinate" : "ip_address";
    return { eventAction, eventLabel };
};

const useUserLandedLocationEvent = () => {
    const userGeoData = useUserGeoLocation();
    const [geoPermissionState, setGeoPermissionState] = useState(null);

    useEffect(() => {
        try {
            if (typeof window !== "undefined" && window.navigator?.permissions?.query) {
                window.navigator.permissions
                    .query({ name: "geolocation" })
                    .then((status) => {
                        setGeoPermissionState(status.state);
                        status.onchange = () => setGeoPermissionState(status.state);
                    })
                    .catch(() => {});
            }
        } catch (_) {
            // silently ignore
        }
    }, []);

    return buildLocationEventPayload(userGeoData, geoPermissionState);
};

export default useUserLandedLocationEvent;
